import React from 'react';
import { OldSwitch } from '@app/form_components';

export default class CommonModuleInstallOptions extends React.Component {

    /**
     * Allow users to Configure Common Modules during import and version changing
     * @module CommonModuleInstallOptions
     * @param {Object} props React props
     */

    constructor(props){
        super(props);
        this.state = {
            redactSensitive: false
        }
    }

    setConfig(key, value){
        if(key === "redactSensitive"){ // turn off if on in the Como
            this.props.commonModule.sensitiveOverrides.enabled = !value;
            this.setState({redactSensitive: value});
            this.props.handleOnChangeConfig(key, value);
        }
    }

    /**
     * Applies user-selected install options to Common Modules during import and version change
     */
    async handleContinue(){
        let commonModule = this.props.commonModule;
        const previousCommonModule = this.props.previousCommonModule;
        const disableRedaction = this.state.redactSensitive;
        
        // import is from NewElementDialog
        const { commonModuleManager } = window.apm;

        if(this.props.type === "import"){
            await commonModuleManager.importCommonModule(commonModule, null, disableRedaction);
        } 
        // versionChange is from CommonModuleChangeVersionDialog
        if(this.props.type === "versionChange"){
            await commonModuleManager.changeCommonModuleVersion(commonModule, previousCommonModule, disableRedaction);
        }
    }

    render(){
    
        return (
            <div className="installOptions">
                <div className="body">
                    
                    {/* options */}
                    <div className="options">
                        <h4> <i className={"fe icon-alert-triangle"} />  Sensitive Data Override </h4> 
                        <p>This Common Module treats some data as sensitive.</p>
                        <p>All data in Common Module will be logged in plain text.</p>
                        <p>Select <b>Disable Sensitive Data Redaction</b> to disable sensitive fields in this common module.</p>
                        <OldSwitch 
                            label="Disable Sensitive Data Redaction"
                            context={this}
                            valKey="redactSensitive"
                            checked={this.state.redactSensitive}
                        />
                    </div>

                </div>

            </div>
        )
    }
    
}